import { fetcher } from "@/services/api/fetcher";
import { useQuery } from "@tanstack/react-query";
import { AgencyMemberByIdResponse } from "./interface";

//SECTION - Get All Alsintan
const getAgencyMember = async (
  id: string
): Promise<ApiResponse<DataPaginate<AgencyMemberByIdResponse>>> => {
  return await fetcher(`master/user?instansiId=${id}`);
};

export const useGetAgencyMember = (id: string) => {
  return useQuery<ApiResponse<DataPaginate<AgencyMemberByIdResponse>>, Error>({
    queryKey: ["useGetAgencyMember", id],
    queryFn: () => getAgencyMember(id),
    keepPreviousData: true,
    refetchIntervalInBackground: true,
    enabled: !!id,
  });
};
